// Simplified taxonomy structure without listenQuery

import {StructureBuilder, StructureResolverContext} from 'sanity/structure'
import {BiCollection, BiEdit} from 'react-icons/bi'
import {map} from 'rxjs/operators'

export default function categoriesTaxonomy(
  S: StructureBuilder,
  context: StructureResolverContext,
) {
  const categoryClusterSchemaType = 'blog.category-cluster'
  const categorySchemaType = 'blog.category'
  const postSchemaType = 'blog.post'

  const documentStore = context.documentStore

  return S.listItem()
    .title('Categories')
    .icon(BiCollection)
    .child(() =>
      documentStore
        .listenQuery(
          `*[_type == $clusterType && !(_id in path("drafts.**"))] | order(title asc) {
            _id,
            title
          }`,
          {clusterType: categoryClusterSchemaType},
          {apiVersion: '2025-01-01'},
        )
        .pipe(
          map((clusters: any[]) =>
            S.list()
              .title('Categories')
              .items([
                // All Clusters
                S.listItem()
                  .title('All Clusters')
                  .icon(BiCollection)
                  .child(
                    S.documentList()
                      .title('All Clusters')
                      .schemaType(categoryClusterSchemaType)
                      .filter(`_type == "${categoryClusterSchemaType}"`)
                      .defaultOrdering([{field: 'title', direction: 'asc'}]),
                  ),

                // All Categories
                S.listItem()
                  .title('All Categories')
                  .icon(BiCollection)
                  .child(
                    S.documentList()
                      .title('All Categories')
                      .schemaType(categorySchemaType)
                      .filter(`_type == "${categorySchemaType}"`)
                      .defaultOrdering([{field: 'title', direction: 'asc'}]),
                  ),

                S.divider({id: 'divider-by-cluster', type: 'divider', title: 'By Cluster'}),

                // Clusters inline at top level
                ...clusters.map((cluster) =>
                  S.listItem()
                    .id(cluster._id)
                    .title(cluster.title || 'Untitled')
                    .icon(BiCollection)
                    .child(() =>
                      documentStore
                        .listenQuery(
                          `*[_type == $categoryType && !(_id in path("drafts.**")) && cluster._ref == $clusterId] | order(title asc) {
                            _id,
                            title
                          }`,
                          {categoryType: categorySchemaType, clusterId: cluster._id},
                          {apiVersion: '2025-01-01'},
                        )
                        .pipe(
                          map((categories: any[]) =>
                            S.list()
                              .title(cluster.title || 'Untitled')
                              .items([
                                // Edit the cluster itself
                                S.listItem()
                                  .title('Edit Cluster')
                                  .icon(BiEdit)
                                  .child(
                                    S.document()
                                      .documentId(cluster._id)
                                      .schemaType(categoryClusterSchemaType),
                                  ),

                                S.divider({
                                  id: 'divider-categories',
                                  type: 'divider',
                                  title: 'Categories',
                                }),

                                // List categories inline
                                ...categories.map((category) =>
                                  S.listItem()
                                    .id(category._id)
                                    .title(category.title || 'Untitled')
                                    .icon(BiCollection)
                                    .child(() =>
                                      documentStore
                                        .listenQuery(
                                          `*[_type == $postType && !(_id in path("drafts.**")) && mainCategory._ref == $categoryId] | order(publishDate desc) {
                                            _id,
                                            title,
                                            publishDate
                                          }`,
                                          {postType: postSchemaType, categoryId: category._id},
                                          {apiVersion: '2025-01-01'},
                                        )
                                        .pipe(
                                          map((posts: any[]) =>
                                            S.list()
                                              .title(category.title || 'Untitled')
                                              .items([
                                                // Edit the category itself
                                                S.listItem()
                                                  .title('Edit Category')
                                                  .icon(BiEdit)
                                                  .child(
                                                    S.document()
                                                      .documentId(category._id)
                                                      .schemaType(categorySchemaType),
                                                  ),

                                                S.divider({
                                                  id: 'divider-posts',
                                                  type: 'divider',
                                                  title: 'Posts',
                                                }),

                                                // List posts inline
                                                ...posts.map((post) =>
                                                  S.documentListItem()
                                                    .id(post._id)
                                                    .schemaType(postSchemaType)
                                                    .title(post.title || 'Untitled'),
                                                ),
                                              ]),
                                          ),
                                        ),
                                    ),
                                ),
                              ]),
                          ),
                        ),
                    ),
                ),
              ]),
          ),
        ),
    )
}
